import React, { useState } from 'react';
import { SearchIcon, FilterIcon, TrendingUpIcon, ClockIcon, StarIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface GalleryItem {
  id: number;
  title: string;
  creator: string;
  creatorType: 'photographer' | 'model' | 'designer';
  category: string;
  imageUrl: string;
  likes: number;
  date: string;
  tags: string[];
}
const galleryData: GalleryItem[] = [{
  id: 1,
  title: 'Fantasy Book Cover',
  creator: 'Sarah Chen',
  creatorType: 'photographer',
  category: 'Book Covers',
  imageUrl: 'https://images.unsplash.com/photo-1614813651945-964c6686e3e8',
  likes: 234,
  date: '2023-09-15',
  tags: ['Fantasy', 'Magic', 'Dark']
}, {
  id: 2,
  title: 'Romance Novel Portrait',
  creator: 'Elena Martinez',
  creatorType: 'model',
  category: 'Author Portraits',
  imageUrl: 'https://images.unsplash.com/photo-1621784563330-caee0b138a00',
  likes: 189,
  date: '2023-09-20',
  tags: ['Romance', 'Contemporary', 'Portrait']
}, {
  id: 3,
  title: 'Sci-Fi Book Design',
  creator: 'Alex Thompson',
  creatorType: 'designer',
  category: 'Book Covers',
  imageUrl: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679',
  likes: 312,
  date: '2023-09-18',
  tags: ['Sci-Fi', 'Space', 'Futuristic']
}, {
  id: 4,
  title: 'Mystery Thriller Cover',
  creator: 'James Wilson',
  creatorType: 'photographer',
  category: 'Book Covers',
  imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85',
  likes: 167,
  date: '2023-09-12',
  tags: ['Thriller', 'Mystery', 'Dark']
}, {
  id: 5,
  title: 'YA Fantasy Model Shot',
  creator: 'Sofia Chen',
  creatorType: 'model',
  category: 'Book Covers',
  imageUrl: 'https://images.unsplash.com/photo-1621784562877-61edbc5bff51',
  likes: 245,
  date: '2023-09-25',
  tags: ['Fantasy', 'YA', 'Portrait']
}, {
  id: 6,
  title: 'Historical Fiction Design',
  creator: 'Maria Garcia',
  creatorType: 'designer',
  category: 'Book Covers',
  imageUrl: 'https://images.unsplash.com/photo-1614728894747-a83421789c10',
  likes: 198,
  date: '2023-09-22',
  tags: ['Historical', 'Classic', 'Vintage']
}];
export default function Gallery() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const filteredItems = galleryData.filter(item => (selectedCategory === 'All' || item.creatorType === selectedCategory) && (searchQuery === '' || item.title.toLowerCase().includes(searchQuery.toLowerCase()) || item.creator.toLowerCase().includes(searchQuery.toLowerCase()) || item.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())))).sort((a, b) => sort === 'popular' ? b.likes - a.likes : new Date(b.date).getTime() - new Date(a.date).getTime());
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-15322" data-mp="j12mek3wyuu8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15323" data-mp="wt91e2vbyvs3">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-15324" data-mp="sre3z9git2jl">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-15325" data-mp="ssfi5msu255j">
            Creative Gallery
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-15326" data-mp="5237i467dub9">
            Explore our collection of professional book covers, author
            portraits, and design work
          </p>
        </div>
        {/* Search and Filters */}
        <div className="mb-8 flex flex-col sm:flex-row gap-4" data-id="element-15327" data-mp="9350w4dfvc5b">
          <div className="relative flex-1" data-id="element-15328" data-mp="91tvk04chwc3">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-15329" data-mp="1ph501d4gmxri" />
            <input type="text" placeholder="Search by title, creator, or tags..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-15330" data-mp="1kj3emljkamcv" />
          </div>
          <div className="flex gap-4" data-id="element-15331" data-mp="2uphihvcc7rwo">
            <div className="relative" data-id="element-15332" data-mp="2uqiuq353akfz">
              <FilterIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-15333" data-mp="2unej4kpaomfa" />
              <select className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none bg-white" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} data-id="element-15334" data-mp="33qfo2i2fc7hd">
                <option value="All" data-id="element-15335" data-mp="3ifvd9tmb44uy">All Work</option>
                <option value="photographer" data-id="element-15336" data-mp="3ih6f3nw6z2jf">Photography</option>
                <option value="model" data-id="element-15337" data-mp="3mhyqonsjdjiv">Modeling</option>
                <option value="designer" data-id="element-15338" data-mp="3mekkt5knys6o">Design</option>
              </select>
            </div>
            <div className="flex border border-gray-300 rounded-lg overflow-hidden" data-id="element-15339" data-mp="1ar8rm8jjx46u">
              <button onClick={() => setSort('popular')} className={`px-4 py-2 flex items-center ${sort === 'popular' ? 'bg-purple-100 text-purple-600' : 'bg-white text-gray-600'}`} data-id="element-15340" data-mp="16qox7cqd4eoe">
                <TrendingUpIcon className="h-5 w-5 mr-1" data-id="element-15341" data-mp="1uhb3aygt3ovr" />
                Popular
              </button>
              <button onClick={() => setSort('recent')} className={`px-4 py-2 flex items-center ${sort === 'recent' ? 'bg-purple-100 text-purple-600' : 'bg-white text-gray-600'}`} data-id="element-15342" data-mp="1piq3h05gv77u">
                <ClockIcon className="h-5 w-5 mr-1" data-id="element-15343" data-mp="1frn3k1o9wya5" />
                Recent
              </button>
            </div>
          </div>
        </div>
        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-15344" data-mp="28gtykqoir5qn">
          {filteredItems.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-15345" data-mp="6kld3eaucuz2">
              <div className="relative aspect-w-3 aspect-h-2" data-id="element-15346" data-mp="3szeb8gu9pl2s">
                <img src={item.imageUrl} alt={item.title} className="w-full h-64 object-cover" data-id="element-15347" data-mp="3sz4gyh26wrra" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-15348" data-mp="3j05i1q788ahh" />
                <div className="absolute bottom-4 left-4 right-4" data-id="element-15349" data-mp="3o1cptp9dd9o5">
                  <h3 className="text-lg font-semibold text-white mb-1" data-id="element-15350" data-mp="3a0ii78u5bcqj">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-200" data-id="element-15351" data-mp="3eyts1jkfxn8r">by {item.creator}</p>
                </div>
              </div>
              <div className="p-4" data-id="element-15352" data-mp="18agqfa7ijoy9">
                <div className="flex items-center justify-between mb-3" data-id="element-15353" data-mp="187b2vzej8v4n">
                  <span className={`px-3 py-1 bg-purple-100 text-purple-700 ${rt.badgeRadius} text-sm`} data-id="element-15354" data-mp="1d7qfgoqzpylk">
                    {item.category}
                  </span>
                  <div className="flex items-center text-gray-600" data-id="element-15355" data-mp="1iex3xwxistyw">
                    <StarIcon className="h-5 w-5 text-yellow-400 mr-1" data-id="element-15356" data-mp="1w5ip5sag5fzy" />
                    {item.likes}
                  </div>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-15357" data-mp="1rbxottlds9xl">
                  {item.tags.map(tag => <span key={tag} className={`px-2 py-1 bg-gray-100 text-gray-600 ${rt.badgeRadius} text-xs`} data-id="element-15358" data-mp="264hnagxl5t8p">
                      {tag}
                    </span>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}